export default "__VITE_ASSET__tb7id4Le__"